import React, { useState, useContext } from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import CardProductFacebook from '../CardProductFacebook';
import Input from '../Input';
import Select from '../Select';
import styled from 'styled-components';
import { PostsContext } from '../../context/posts';
import TextAreaPosts from '../TextAreaPosts';
import animation from '../../images/animated/Animation - 1741800304076.json'
import animationFacebook from '../../images/animated/Animation - 1741616968234.json'
import PreviewFacebook from '../PreviewFacebook';
import Lottie from 'react-lottie';


const CardInput = styled.section`

    display: flex;
    width: 100%;
    margin-bottom: 0.9em;


    input,select{
        width: 100%;
        height: 50px;
        border-radius: 10px;
    }

    div > label{
        font-size: 0.9rem;
    }

    .textPrimary{
        color: black;
        font-family: "Poppins";
        font-weight: 500;
        margin-bottom: 0rem;
        font-size: 1.2rem;
    }

    div{
        margin-right:1.5rem;
    }

    @media screen and (max-width:720px){
        flex-direction: column;
        div{
            margin-left: 0rem;
        }

    }


`
const ContainerProducts = styled.div`

`
const CardWrapper = styled.div`
    width: 96%;
`
const CardAnimated = styled.div`
    display:flex;
    align-items:center ;


    p{
        font-family: "Poppins";
        font-weight: 500;
        text-align: center;
        font-size: 1.2rem;
    }

`
const ContainerPreview = styled.div`
    margin-top: 0.9rem;
    display:flex;
    align-items: center;
    justify-content: space-around;

`

const ModalGoogle = (props) => {
    const { 
        getProducts,
        products,
        storageFacebook,
        btnDisable,
        handeImage,
        storagePersonalizateFacebook,
        setNamePost,
        storageGoogle
    } = useContext(PostsContext)
    const [typePost, setTypePost] = useState()

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    }
    const defaultOptionsFacebook = {
        loop: true,
        autoplay: true,
        animationData: animationFacebook,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    }

    const data = [
        {
            name: "Post Produtos"
        }
    ]

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Informações do post
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>


                <CardInput>
                    <Select name={"Tipo de post *"} onChange={(e) => setTypePost(e.target.value)} data={data} target="name" />
                </CardInput>

                {typePost == "Post Produtos"

                    ?

                    <>
                        <CardInput>
                            <Input name={"Pesquise um produto *"} placeholder="Pesquise um produto ex: Fiat" onChange={(e) => getProducts(e.target.value)} type={"text"} />
                        </CardInput>

                        <ContainerProducts>
                            {products?.map(item => {
                                return (
                                    <CardProductFacebook name={item.name} image={item.product_image} id={item.product_id} />
                                )
                            })}

                        </ContainerProducts>
                    </>

                    :
                    typePost == "Post Personalizado"

                        ?


                        <>
                            <CardInput>
                                <Input name={"Nome do post *"} onChange={(e) => setNamePost(e.target.value)} type={"text"} />
                                <Input name={"Imagem do post *"} accept=".png, .jpg, .jpeg"  onChange={(e) => handeImage(e.target.files[0])} type={"file"} />

                            </CardInput>
                            <CardWrapper>
                                <TextAreaPosts />
                            </CardWrapper>
                            <ContainerPreview>
                            
                            <Lottie options={defaultOptionsFacebook}
                                height={100}
                                width={100}
                            />

                            <PreviewFacebook />
                            
                            </ContainerPreview>
                        </>

                        :
                        <CardAnimated>
                            <Lottie options={defaultOptions}
                                height={270}
                                width={270}
                            />
                            <p>Informe um tipo de post para começarmos...</p>

                        </CardAnimated>

                }

            </Modal.Body>
            {typePost == "Selecione" || !typePost || typePost == "Selecione"

                ?
                <></>
                :
                <Modal.Footer>

                    <Button disabled={btnDisable} onClick={() => { typePost == "Post Personalizado" ? storagePersonalizateFacebook() : storageGoogle() }} >Adicionar Post</Button>
                </Modal.Footer>
            }

        </Modal>
    )
}

export default ModalGoogle